import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import React from "react";

type Props = {
  data: Simplify<Content.EngagementDevelopmentSectionSliceDefaultPrimaryEngagementHelpCardsItem>;
};

export default function EngageHelpCard({ data }: Props) {
  return (
    <Card className="shadow-none border-none bg-[#044771] text-white relative z-10">
      <CardHeader>
        <CardTitle>
          <div className="flex items-center gap-4">
            <Button
              size="icon"
              className="rounded-full shrink-0 size-14 bg-transparent hover:bg-transparent"
              variant="outline"
            >
              <PrismicNextImage field={data.icon} alt="" />
            </Button>

            <p className="text-3xl font-semibold">{data.title}</p>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="md:px-24">
        <PrismicRichText
          field={data.description}
          components={{
            paragraph: ({ children }) => (
              <p className="text-lg font-merriweather">{children}</p>
            ),
          }}
        />
      </CardContent>
    </Card>
  );
}
